var _path, _path2, _path3, _path4, _rect, _g, _circle, _path5, _rect2, _g2, _path6, _path7, _path8, _path9, _circle2, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgNoObstruction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 236,
    height: 82,
    viewBox: "0 0 236 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.875 20.5681V6.13261C1.875 3.29795 4.17295 1 7.00762 1H21.7639",
    stroke: "#0F574E",
    strokeWidth: 1.92473,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.875 60.6663V75.1018C1.875 77.9364 4.17295 80.2344 7.00762 80.2344H21.7639",
    stroke: "#0F574E",
    strokeWidth: 1.92473,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M107.734 20.5681V6.13261C107.734 3.29795 105.436 1 102.602 1H87.8455",
    stroke: "#0F574E",
    strokeWidth: 1.92473,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M107.734 60.6663V75.1018C107.734 77.9364 105.436 80.2344 102.602 80.2344H87.8455",
    stroke: "#0F574E",
    strokeWidth: 1.92473,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5171_91242",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 10,
    width: 86,
    height: 61
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.9994,
    y: 11.3822,
    width: 83.5407,
    height: 58.47,
    rx: 5.535,
    fill: "white",
    stroke: "#0F574E",
    strokeWidth: 1.47
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5171_91242)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.1953,
    y: 12.1172,
    width: 89.4511,
    height: 59.4385,
    rx: 4.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3671 60.5834H42.9635C44.5922 60.5834 45.9172 59.207 45.9172 57.5161V41.3993C45.9172 39.7084 44.5921 38.332 42.9635 38.332H24.3671C22.7392 38.332 21.4141 39.7084 21.4141 41.3993V57.5161C21.4141 59.207 22.7392 60.5834 24.3671 60.5834ZM39.0192 58.9809H28.3122V57.8878C28.3122 55.9182 29.3106 54.1962 30.8017 53.2084C31.6443 53.7486 32.6224 54.0641 33.669 54.0641C34.7134 54.0641 35.6893 53.7492 36.5305 53.21C38.021 54.198 39.0192 55.919 39.0192 57.888V58.9809ZM29.5371 47.8867C29.5371 45.3594 31.391 43.3039 33.669 43.3039C35.9433 43.3039 37.7941 45.3594 37.7941 47.8867C37.7941 50.4093 35.9433 52.4616 33.669 52.4616C31.3911 52.4616 29.5371 50.4092 29.5371 47.8867ZM22.9569 41.3993C22.9569 40.5917 23.5897 39.9345 24.3671 39.9345H42.9635C43.7416 39.9345 44.3745 40.5917 44.3745 41.3993V57.5161C44.3745 58.3237 43.7417 58.9809 42.9635 58.9809H40.5618V57.8878C40.5618 55.5344 39.4542 53.4548 37.7618 52.1484C38.7351 51.0387 39.337 49.5391 39.337 47.8865C39.337 44.4759 36.7945 41.7012 33.669 41.7012C30.5397 41.7012 27.9943 44.4757 27.9943 47.8865C27.9943 49.537 28.5955 51.0346 29.5675 52.1439C27.874 53.4496 26.7694 55.5336 26.7694 57.8878V58.9809H24.3671C23.5897 58.9809 22.9569 58.3237 22.9569 57.5161V41.3993Z",
    fill: "#0F574E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2522 38.9414H54.6792C54.2389 38.9414 53.8828 39.2823 53.8828 39.7034C53.8828 40.1247 54.2391 40.4655 54.6792 40.4655H76.2522C76.6925 40.4655 77.0486 40.1246 77.0486 39.7034C77.0486 39.2823 76.6925 38.9414 76.2522 38.9414Z",
    fill: "#0F574E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2522 42.5996H54.6792C54.2389 42.5996 53.8828 42.9405 53.8828 43.3616C53.8828 43.7829 54.2391 44.1237 54.6792 44.1237H76.2522C76.6925 44.1237 77.0486 43.7828 77.0486 43.3616C77.0486 42.9405 76.6925 42.5996 76.2522 42.5996Z",
    fill: "#0F574E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1869 48.6953H54.6803C54.2394 48.6953 53.8828 49.0362 53.8828 49.4573C53.8828 49.8786 54.2396 50.2194 54.6803 50.2194H91.1869C91.6278 50.2194 91.9844 49.8785 91.9844 49.4573C91.9844 49.0361 91.6278 48.6953 91.1869 48.6953Z",
    fill: "#0F574E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1869 54.791H54.6803C54.2394 54.791 53.8828 55.1319 53.8828 55.553C53.8828 55.9743 54.2396 56.3151 54.6803 56.3151H91.1869C91.6278 56.3151 91.9844 55.9742 91.9844 55.553C91.9844 55.1318 91.6278 54.791 91.1869 54.791Z",
    fill: "#0F574E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6211 6.78006C90.3362 7.05066 94.4908 7.55071 98.1379 8.31131C99.9613 8.69158 101.671 9.13981 103.14 9.66227C104.6 10.1813 105.869 10.7887 106.779 11.5079C107.687 12.2256 108.343 13.1447 108.305 14.2707C108.268 15.3686 107.574 16.4128 106.407 17.4113C104.07 19.4099 99.3304 21.6544 91.3811 24.2081C75.9742 29.1573 58.4874 29.515 42.6761 27.8967C26.8588 26.2779 12.6631 22.6754 3.80689 19.6583C2.27986 19.138 1.09867 17.96 0.519925 16.4756L0.380414 16.1161C-0.906763 12.8143 1.18677 9.18006 4.68289 8.64788L35.8522 3.90403C36.235 3.84575 36.6234 3.82729 37.0102 3.85014L86.6211 6.78006Z",
    fill: "#A8F0E7",
    stroke: "#0F574E",
    strokeWidth: 1.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9717 18.0889C33.9864 18.089 37.2012 21.4432 37.2012 25.5303C37.2011 29.6172 33.9864 32.9705 29.9717 32.9707C25.9568 32.9707 22.7413 29.6173 22.7412 25.5303C22.7412 21.4431 25.9568 18.0889 29.9717 18.0889Z",
    fill: "#51E1CE",
    stroke: "#0F574E",
    strokeWidth: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.9994,
    y: 11.3822,
    width: 83.5407,
    height: 58.47,
    rx: 5.535,
    stroke: "#0F574E",
    strokeWidth: 1.47
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 97.0081,
    cy: 11.7561,
    r: 7.52371,
    fill: "#ECFDF5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8438 4.05078C95.2306 4.05078 93.6537 4.51264 92.3124 5.37796C90.9711 6.24327 89.9257 7.47318 89.3084 8.91215C88.691 10.3511 88.5295 11.9345 88.8442 13.4621C89.1589 14.9897 89.9357 16.3929 91.0764 17.4942C92.2171 18.5956 93.6704 19.3456 95.2525 19.6495C96.8347 19.9533 98.4747 19.7974 99.965 19.2013C101.455 18.6053 102.729 17.5959 103.625 16.3009C104.522 15.0059 105 13.4833 105 11.9258C105 9.8372 104.141 7.83416 102.611 6.35732C101.081 4.88047 99.0069 4.05078 96.8438 4.05078ZM95.6786 15.0706L92.7656 12.2581L93.6923 11.3633L95.6786 13.281L99.9956 9.11328L100.925 10.0054L95.6786 15.0706Z",
    fill: "#00D492"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_5171_91242",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 138,
    y: 10,
    width: 86,
    height: 61
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 139.265,
    y: 10.8822,
    width: 83.5407,
    height: 58.47,
    rx: 5.535,
    fill: "white",
    stroke: "#0F574E",
    strokeWidth: 1.47
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_5171_91242)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 136.461,
    y: 11.6172,
    width: 89.4511,
    height: 59.4385,
    rx: 4.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.633 60.0834L169.229 60.0834C170.858 60.0834 172.183 58.707 172.183 57.0161L172.183 40.8993C172.183 39.2084 170.858 37.832 169.229 37.832L150.633 37.832C149.005 37.832 147.68 39.2084 147.68 40.8993L147.68 57.0161C147.68 58.707 149.005 60.0834 150.633 60.0834ZM165.285 58.4809L154.578 58.4809L154.578 57.3878C154.578 55.4182 155.576 53.6962 157.067 52.7084C157.91 53.2486 158.888 53.5641 159.935 53.5641C160.979 53.5641 161.955 53.2492 162.796 52.71C164.287 53.698 165.285 55.419 165.285 57.388L165.285 58.4809ZM155.803 47.3867C155.803 44.8594 157.657 42.8039 159.935 42.8039C162.209 42.8039 164.06 44.8594 164.06 47.3867C164.06 49.9093 162.209 51.9616 159.935 51.9616C157.657 51.9616 155.803 49.9092 155.803 47.3867ZM149.223 40.8993C149.223 40.0917 149.855 39.4345 150.633 39.4345L169.229 39.4345C170.007 39.4345 170.64 40.0917 170.64 40.8993L170.64 57.0161C170.64 57.8237 170.007 58.4809 169.229 58.4809L166.827 58.4809L166.827 57.3878C166.827 55.0344 165.72 52.9548 164.027 51.6484C165.001 50.5387 165.603 49.0391 165.603 47.3865C165.603 43.9759 163.06 41.2012 159.935 41.2012C156.805 41.2012 154.26 43.9757 154.26 47.3865C154.26 49.0369 154.861 50.5346 155.833 51.6439C154.14 52.9496 153.035 55.0336 153.035 57.3878L153.035 58.4809L150.633 58.4809C149.855 58.4809 149.223 57.8237 149.223 57.0161L149.223 40.8993Z",
    fill: "#0F574E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.518 38.4414L180.945 38.4414C180.505 38.4414 180.148 38.7823 180.148 39.2034C180.148 39.6247 180.505 39.9655 180.945 39.9655L202.518 39.9655C202.958 39.9655 203.314 39.6246 203.314 39.2034C203.314 38.7823 202.958 38.4414 202.518 38.4414Z",
    fill: "#0F574E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.518 42.0996L180.945 42.0996C180.505 42.0996 180.148 42.4405 180.148 42.8616C180.148 43.2829 180.505 43.6237 180.945 43.6237L202.518 43.6237C202.958 43.6237 203.314 43.2828 203.314 42.8616C203.314 42.4405 202.958 42.0996 202.518 42.0996Z",
    fill: "#0F574E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.453 48.1953L180.946 48.1953C180.505 48.1953 180.148 48.5362 180.148 48.9573C180.148 49.3786 180.505 49.7194 180.946 49.7194L217.453 49.7194C217.893 49.7194 218.25 49.3785 218.25 48.9573C218.25 48.5361 217.893 48.1953 217.453 48.1953Z",
    fill: "#0F574E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.453 54.291L180.946 54.291C180.505 54.291 180.148 54.6319 180.148 55.053C180.148 55.4743 180.505 55.8151 180.946 55.8151L217.453 55.8151C217.893 55.8151 218.25 55.4742 218.25 55.053C218.25 54.6318 217.893 54.291 217.453 54.291Z",
    fill: "#0F574E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.887 6.28006C216.602 6.55066 220.756 7.05071 224.404 7.81131C226.227 8.19158 227.936 8.63981 229.406 9.16227C230.866 9.68134 232.135 10.2887 233.045 11.0079C233.952 11.7256 234.609 12.6447 234.571 13.7707C234.534 14.8686 233.84 15.9128 232.673 16.9113C230.336 18.9099 225.596 21.1544 217.647 23.7081C202.24 28.6573 184.753 29.015 168.942 27.3967C153.124 25.7779 138.929 22.1754 130.073 19.1583C128.545 18.638 127.364 17.46 126.786 15.9756L126.646 15.6161C125.359 12.3143 127.452 8.68006 130.949 8.14788L162.118 3.40403C162.501 3.34575 162.889 3.32729 163.276 3.35014L212.887 6.28006Z",
    fill: "#A8F0E7",
    stroke: "#0F574E",
    strokeWidth: 1.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.237 17.5889C160.252 17.589 163.467 20.9432 163.467 25.0303C163.467 29.1172 160.252 32.4705 156.237 32.4707C152.222 32.4707 149.007 29.1173 149.007 25.0303C149.007 20.9431 152.222 17.5889 156.237 17.5889Z",
    fill: "#51E1CE",
    stroke: "#0F574E",
    strokeWidth: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.265,
    y: 10.8822,
    width: 83.5407,
    height: 58.47,
    rx: 5.535,
    stroke: "#0F574E",
    strokeWidth: 1.47
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M128.266 20.5681V6.13261C128.266 3.29795 130.564 1 133.398 1H148.155",
    stroke: "#0F574E",
    strokeWidth: 1.92473,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M128.266 60.6663V75.1018C128.266 77.9364 130.564 80.2344 133.398 80.2344H148.155",
    stroke: "#0F574E",
    strokeWidth: 1.92473,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M234.125 20.5681V6.13261C234.125 3.29795 231.827 1 228.992 1H214.236",
    stroke: "#0F574E",
    strokeWidth: 1.92473,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M234.125 60.6663V75.1018C234.125 77.9364 231.827 80.2344 228.992 80.2344H214.236",
    stroke: "#0F574E",
    strokeWidth: 1.92473,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 223.399,
    cy: 11.7561,
    r: 7.52371,
    fill: "#ECFDF5"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M223.234 4.05078C218.69 4.05078 215.078 7.53828 215.078 11.9258C215.078 16.3133 218.69 19.8008 223.234 19.8008C227.779 19.8008 231.391 16.3133 231.391 11.9258C231.391 7.53828 227.779 4.05078 223.234 4.05078ZM226.38 15.8633L223.234 12.8258L220.088 15.8633L219.156 14.9633L222.302 11.9258L219.156 8.88828L220.088 7.98828L223.234 11.0258L226.38 7.98828L227.312 8.88828L224.167 11.9258L227.312 14.9633L226.38 15.8633Z",
    fill: "#FF6467"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M152 40.3525C156.012 40.3525 159.265 43.6048 159.265 47.6172C159.265 51.6295 156.012 54.8818 152 54.8818H130.735V40.3525H152Z",
    fill: "#D3F8F3",
    stroke: "#0F574E",
    strokeWidth: 1.47
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M152.668 44.1172C154.601 44.1172 156.168 45.6842 156.168 47.6172C156.168 49.5502 154.601 51.1172 152.668 51.1172H149.391V44.1172H152.668Z",
    fill: "white",
    stroke: "#0F574E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgNoObstruction);
export default __webpack_public_path__ + "static/media/img-no-obstruction.bef94302be0859f4a5c1915b977eb54c.svg";
export { ForwardRef as ReactComponent };